import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import {
  IAppSlice,
  IEditSlice,
  IHomeSlice,
  IPatternSlice,
  ISearchSlice,
  IUserSlice,
  INotificationSlice,
  IResetSlice,
  topicsCacheSlice,
} from '@/types'
import {
  createAppSlice,
  createHomeSlice,
  createUserSlice,
  createEditSlice,
  createSearchSlice,
  createPatternSlice,
  createNotificationSlice,
  resetAllSlices,
} from './slices'
import {
  createWorkspacePatternsSlice,
  createWorkspaceCollectionsSlice,
  createWorkspacePinsSlice,
  createDiscoverPatternsSlice,
  createDiscoverCollectionsSlice,
  createDiscoverPinsSlice,
} from './slices/topicsCache'
import { TopicsCacheKey } from '@/utils/cacheKeys'

type CombinedSlice = IAppSlice &
  IHomeSlice &
  IUserSlice &
  IEditSlice &
  ISearchSlice &
  IPatternSlice &
  INotificationSlice &
  IResetSlice &
  topicsCacheSlice<TopicsCacheKey.Workspace_Patterns> &
  topicsCacheSlice<TopicsCacheKey.Workspace_Collections> &
  topicsCacheSlice<TopicsCacheKey.Workspace_Pins> &
  topicsCacheSlice<TopicsCacheKey.Discover_Patterns> &
  topicsCacheSlice<TopicsCacheKey.Discover_Collections> &
  topicsCacheSlice<TopicsCacheKey.Discover_Pins>

export const useAppStore = create<CombinedSlice>()(
  persist(
    (set, get, api) => ({
      ...createAppSlice(set),
      ...createHomeSlice(set),
      ...createUserSlice(set),
      ...createEditSlice(set),
      ...createSearchSlice(set),
      ...createPatternSlice(set),
      ...createNotificationSlice(set),
      ...resetAllSlices(set, get, api),
      ...createWorkspacePatternsSlice(set),
      ...createWorkspaceCollectionsSlice(set),
      ...createWorkspacePinsSlice(set),
      ...createDiscoverPatternsSlice(set),
      ...createDiscoverCollectionsSlice(set),
      ...createDiscoverPinsSlice(set),
    }),
    {
      name: 'appStore',
      partialize: (state) => {
        const {
          [TopicsCacheKey.Workspace_Patterns]: _wp,
          [TopicsCacheKey.Workspace_Collections]: _wc,
          [TopicsCacheKey.Workspace_Pins]: _wpn,
          [TopicsCacheKey.Discover_Patterns]: _dp,
          [TopicsCacheKey.Discover_Collections]: _dc,
          [TopicsCacheKey.Discover_Pins]: _dpn,
          ...persistedState
        } = state
        return persistedState
      },
    },
  ),
)

export const clearAllStores = () => {
  useAppStore.getState().resetAll()
  window.localStorage.removeItem('appStore')
  useAppStore.persist.clearStorage()
}

export default useAppStore
